var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome100(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 30,
    viewBox: "0 0 28 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.625 27.4468H9.1875V16.8085H18.8125V27.4468H25.375V10.8511L14 2.55319L2.625 10.8511V27.4468ZM2.625 30C1.90313 30 1.28516 29.75 0.771094 29.25C0.257031 28.75 0 28.1489 0 27.4468V10.8511C0 10.4468 0.0929687 10.0638 0.278906 9.70213C0.464844 9.34043 0.721875 9.04255 1.05 8.80851L12.425 0.510638C12.6669 0.340426 12.9199 0.212766 13.1838 0.12766C13.4477 0.0425532 13.7227 0 14.0086 0C14.2945 0 14.5675 0.0425532 14.8275 0.12766C15.0875 0.212766 15.3367 0.340426 15.575 0.510638L26.95 8.80851C27.2781 9.04255 27.5352 9.34043 27.7211 9.70213C27.907 10.0638 28 10.4468 28 10.8511V27.4468C28 28.1489 27.743 28.75 27.2289 29.25C26.7148 29.75 26.0969 30 25.375 30H16.1875V19.3617H11.8125V30H2.625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome100);
export default __webpack_public_path__ + "static/media/home100.11cc5bff81c28bcbc7d2d22daa4b2bb7.svg";
export { ForwardRef as ReactComponent };